<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import SimpleDropdown from "~/components/Common/Dropdowns/SimpleDropdown.vue";
import DateInput from "~/components/Common/Inputs/DateInput.vue";
import AreaInput from "~/components/Common/Inputs/AreaInput.vue";
import { unscheduleReasons } from "~/utils/options/unschedule-reasons.options";
import Tooltip from "~/components/Common/Tooltip.vue";
import { useSessionsStore } from "~/store/sessions/sessions-store";
import { PaginationKeysEnum } from "~/utils/enums/pagination-keys.enums";
import { useSessionDetailsAttendeesStore } from "~/store/sessions/session-details-attendees-store";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const emit = defineEmits(["hide"]);
const unscheduleReason = ref<{ value: string; name: string } | null>(null);
const date = ref(new Date());
const comment = ref("");
const sessionDetailsAttendeesStore = useSessionDetailsAttendeesStore();
const sessionsStore = useSessionsStore();
const { trainingPlanSessionIndividual } = storeToRefs(sessionsStore);

onMounted(async () => {
  unscheduleReason.value = trainingPlanSessionIndividual.value?.cancelReason
    ? (unscheduleReasons.find((reason) => reason.value === trainingPlanSessionIndividual.value?.cancelReason) ??
      null)
    : null;
  date.value = trainingPlanSessionIndividual.value?.cancelDate
    ? new Date(trainingPlanSessionIndividual.value?.cancelDate)
    : new Date();
  comment.value = trainingPlanSessionIndividual.value?.cancelComment ?? "";
});

function cancel() {
  emit("hide");
}

async function confirm() {
  if (!trainingPlanSessionIndividual.value?.bookingId || !trainingPlanSessionIndividual.value?.sessionId) return;
  await sessionDetailsAttendeesStore.updateUnscheduleAttendee(
    trainingPlanSessionIndividual.value?.bookingId,
    {
      cancelReason: unscheduleReason.value?.value ?? null,
      cancelDate: new Date(date.value).toISOString(),
      cancelComment: comment.value,
    },
    PaginationKeysEnum.UNSCHEDULE_USERS_PAGINATION,
  );
  emit("hide");
}
</script>

<template>
  <CenterModal :style="{ 'max-width': '488px', width: '100%' }">
    <template #body>
      <div class="grid p-[24px] gap-[24px] body_regular">
        <div class="flex flex-col gap-2">
          <h4 class="heading_4_demi">Détail de la déplanification</h4>
        </div>
        <div class="flex gap-2">
          <div class="w-full">
            <div class="flex flex-row items-center pb-2">
              <p class="body_regular text-secondary-color">Motif</p>
              <Tooltip :position="'top-right'" class="ml-1">
                <template #content>
                  <div class="flex w-[274px] gap-[8px]">
                    <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
                    <span class="font-medium text_kpi"
                      >Le motif sera visible dans les notifications aux participants et aux managers</span
                    >
                  </div>
                </template>
              </Tooltip>
            </div>
            <SimpleDropdown
              v-model="unscheduleReason"
              searchable
              class="max-w-[416px]"
              label="value"
              placeholder="Sélectionner un motif"
              :options="unscheduleReasons"
              track-by="value"
              :hide-selected="true"
              :nb_Element="4"
            >
            </SimpleDropdown>
          </div>
          <div class="w-full">
            <p class="body_regular text-secondary-color pb-2">Date d'annonce</p>
            <DateInput v-model="date" placeholder="Choisir" :teleport="true"></DateInput>
          </div>
        </div>
        <div>
          <p class="body_regular text-secondary-color pb-2">Commentaire :</p>
          <AreaInput
            v-model="comment"
            class="textarea__input overflow-hidden !min-h-[90px]"
            placeholder="Ajouter un commentaire"
          ></AreaInput>
        </div>
        <div class="flex justify-center gap-[16px]">
          <AppButton type="outlined" label="Annuler" class="w-full" @click="cancel" />
          <AppButton label="Enregistrer" class="w-full" @click="confirm" />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
